import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
const EmailIcon = ({email}) => {
    let title, iconClass;
  
    if (!email) {
      title = "EMAIL NON PRESENTE";
      iconClass = "icon-danger";
    } else if (email.includes("@")) {
      title = `EMAIL VALIDA: ${email}`;
      iconClass = "icon-success";
    } else {
      title = "EMAIL NON VALIDA";
      iconClass = "icon-danger";
    }
  
    return (
<span title={title}>
        <svg className={`icon ${iconClass} align-middle`}>
          <use href={`${iconSprite}#it-mail`} />
        </svg>
</span>

    );
  };
  
  export default EmailIcon;